var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeal = function SvgIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "M23.291 34.408v.002H.5V.336h22.791v.002c9.33.13 16.846 6.385 16.846 17.035S32.622 34.278 23.29 34.408"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.093 32.639H2.283V2.11h20.81c8.95.044 15.26 6.006 15.26 15.264 0 9.26-6.31 15.22-15.26 15.265",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#242222",
    d: "M4.662 19.637h5.945v10.636H4.662zm2.973-1.576c2.08 0 3.765-1.675 3.765-3.742s-1.686-3.742-3.765-3.742-3.766 1.675-3.766 3.742 1.686 3.742 3.766 3.742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E54279",
    d: "M35.916 15.897C34.972 4.473 23.093 4.473 23.093 4.473h-9.315v25.802h9.315s12.684 0 12.88-12.605h-4.358v-6.894h1.784v5.12zM18.93 10.776h4.162v1.773h-2.378v.787h2.18v1.576h-2.18v.985h2.576v1.773h-4.36zm-2.649 3.447c0-1.674-1.116-1.674-1.116-1.674h-1.388v-1.773h1.19s2.972 0 2.972 3.447-2.973 3.447-2.973 3.447h-1.189v-1.773h1.388s1.116 0 1.116-1.674m9.927-3.447h2.433l2.09 6.894H28.93l-.375-1.31h-2.287l-.385 1.31H24.08zm1.218 1.822.623 2.033H26.79z"
  })));
};
export default SvgIdeal;